export default {
  ONE_PAGE: 'one_page',
  FUNDRAISING: 'fundraising',
  CAMPAIGN: 'campaign',
  TEAM: 'team',
  IN_MEMORY: 'in_memory',
  UNKNOWN: 'unknown',
};
